import { BACKEND_API_URL } from "../Config";
import { fetchWithAuth, handleApiResponse } from "../Utils";


export const submitConsultation = async ({ payload, files = null, onSuccess, onError } = {}) => {
  try {
    const formData = new FormData();

    formData.append("payload", new Blob([JSON.stringify(payload)], { type: "application/json" }));

    if (Array.isArray(files) && files.length > 0) {
      files.forEach((file) => {
        formData.append("files", file);
      });
    }

    const response = await fetch(
      `${BACKEND_API_URL}/consultation`,
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await handleApiResponse(response, "submitConsultation");
    onSuccess?.(data);
    return data;
  }
  catch (error) {
    if (onError) return onError(error);
    throw error;
  }
};

export const fetchAllConsultations = async ({ auth, page=0, size=20, onSuccess = null, onError = null }) => {
    try {
        const url = `${BACKEND_API_URL}/consultation?page=${page}&size=${size}`;

        const response = await fetchWithAuth(
            url,
            {
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "fetchAllConsultations");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
};

export const fetchConsultationDetailed = async ({ auth, consultationId, onSuccess = null, onError = null }) => {
    try {
        if (!consultationId) return null;

        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/consultation/detailed/${consultationId}`,
            {
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "fetchConsultationDetailed");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const deleteConsultation = async ({auth, consultationId, onSuccess=null, onError=null}) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/consultation/${consultationId}`,
            { method: 'DELETE' },
            auth
        );

        const data = await handleApiResponse(response, "deleteConsultation");
        
        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}